import { render, staticRenderFns } from "./MagicCodes.vue?vue&type=template&id=33eb6d3e&scoped=true"
import script from "./MagicCodes.vue?vue&type=script&lang=js"
export * from "./MagicCodes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../app/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33eb6d3e",
  null
  
)

export default component.exports